/**
 * Format a size value stored in GB for display.
 * >= 1 GB → GB, >= 1 MB → MB, otherwise → KB (or B for tiny values).
 */
const GB_TO_MB = 1024;
const GB_TO_KB = GB_TO_MB * 1024;

export function formatDataSize(sizeGb) {
  const size = parseFloat(sizeGb);

  if (Number.isNaN(size) || size === 0) {
    return '0 KB';
  }

  if (size >= 1) {
    return `${size.toFixed(2)} GB`;
  }

  const sizeMb = size * GB_TO_MB;
  if (sizeMb >= 1) {
    return `${sizeMb.toFixed(2)} MB`;
  }

  const sizeKb = size * GB_TO_KB;
  if (sizeKb >= 1) {
    return `${sizeKb.toFixed(2)} KB`;
  }

  return `${(sizeKb * 1024).toFixed(2)} B`;
}
